import { useNavigate } from 'react-router';
import { Button, Skeleton } from '../../../ds/components';
import { usePropertyCalculations } from '../api';
import { ResultCard } from '../wizard/StepCalculation';
import styles from './PropertyRecordPage.module.css';

/**
 * Property record of an object in Ankaufsprüfung: the current acquisition calculation in Nico Kremer's model (his
 * „Deal-Ergebnis", D-354) with the version it belongs to and the way into Schritt 4 of the wizard.
 */
export function AcquisitionCalculationCard({ propertyId }: { propertyId: string }) {
  const navigate = useNavigate();
  const calculations = usePropertyCalculations(propertyId, true);
  if (calculations.isPending) return <Skeleton variant="block" height={220} />;
  if (calculations.isError) return null;
  const current = calculations.data.current;
  return (
    <div className={styles.calculationCard}>
      <ResultCard
        results={current?.results ?? null}
        salesCommissionPct={current?.inputs.salesCommissionPct ?? null}
        headingId="property-calculation"
      />
      <div className={styles.calculationFoot}>
        <span className={styles.calculationMeta}>
          {current === null
            ? 'Noch keine Kalkulation gespeichert'
            : `Ankaufskalkulation ${current.label} · ${current.summary}${current.legacyNote ? ` · ${current.legacyNote}` : ''}`}
        </span>
        <Button
          variant="secondary"
          size="small"
          onClick={() => void navigate(`/properties/${propertyId}/wizard?step=4`)}
        >
          Zur Kalkulation
        </Button>
      </div>
    </div>
  );
}
